// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","CategoriesList":"bj_a bhp_ea bhp_ke bhp_ju bhp_wl"};